import { LI, UL } from "../../../../AbstractElements";
import { useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import { getCartTotal } from "../../../../Service/Ecommerce.service";

const CartData = () => {
  const { cart } = useAppSelector((state) => state.cartData);

  return (
    <UL className="simple-list qty">
      {cart &&
        cart.map((item) => (
          <LI key={item.id}>
            {item.name} x {item.total}
            <span>${getCartTotal(item)}</span>
          </LI>
        ))}
    </UL>
  );
};

export default CartData;
